/**
 * Design constants for Expert Tips screen.
 * Colors, spacing, and responsive typography from Figma design.
 */

export const EXPERT_TIPS_COLORS = {
  // Primary colors
  primaryBlue: '#01A7C8',
  darkBlue: '#007CAD',
  lightBlue: '#58C5DA',
  lighterBlue: '#C7EDEF',

  // Grayscale
  gray6: '#1B2831',
  gray4: '#4D5762',
  gray3: '#A9B7BE',
  white: '#FFFFFF',

  // Semantic
  textPrimary: '#1B2831',
  textSecondary: '#4D5762',
  cardBackground: '#FFFFFF',
  feedbackBorder: '#C7EDEF',
  feedbackSelectedBg: '#DBF7F8',
  arrowColor: '#01A7C8',
} as const;

export const EXPERT_TIPS_SHADOWS = {
  card: '0px 4px 16px rgba(0, 117, 141, 0.2)',
} as const;

export const EXPERT_TIPS_RADIUS = {
  card: 16,
  likeBadge: 12,
  feedbackButton: 8,
} as const;

/**
 * Responsive spacing utilities for Expert Tips.
 * Breakpoints: default (mobile), sm (640px), md (768px), lg (1024px)
 */
export const EXPERT_TIPS_RESPONSIVE = {
  horizontalPadding: 'px-6 sm:px-8 md:px-10 lg:px-12',
  horizontalMargin: 'mx-6 sm:mx-8 md:mx-10 lg:mx-12',

  sectionGapClasses: 'gap-4 sm:gap-5 md:gap-6',
  elementGapClasses: 'gap-2 sm:gap-2.5 md:gap-3',

  cardPaddingClasses: 'p-4 sm:p-[18px] md:p-5 lg:p-[22px]',
  cardGapClasses: 'gap-3 sm:gap-3.5 md:gap-4',

  feedbackButtonHeightClasses: 'h-12 md:h-14',
  avatarSizeClasses: 'w-10 h-10 sm:w-[42px] sm:h-[42px] md:w-11 md:h-11 lg:w-12 lg:h-12',
  arrowSizeClasses: 'w-6 h-6 md:w-[26px] md:h-[26px] lg:w-7 lg:h-7',
  linkLogoSizeClasses: 'w-6 h-6 md:w-[26px] md:h-[26px] lg:w-7 lg:h-7',
} as const;

/**
 * Responsive typography for Expert Tips.
 */
export const EXPERT_TIPS_TYPOGRAPHY = {
  topicLabel: 'text-xs font-black uppercase tracking-[0.06em]',
  topicTitle: 'text-[32px] font-bold tracking-[-0.04em] leading-none',

  tipTitle: 'text-[18px] sm:text-[19px] md:text-[20px] lg:text-[22px]',
  tipBody: 'text-base md:text-lg lg:text-xl',

  expertName: 'text-sm md:text-[15px] lg:text-base',
  expertSubtitle: 'text-xs md:text-[13px] lg:text-sm',

  likeCount: 'text-xs md:text-[13px] lg:text-sm',

  furtherReadingTitle: 'text-[18px] md:text-[20px] lg:text-[22px]',
  linkResourceTitle: 'text-sm md:text-[15px] lg:text-base',

  feedbackButtonLabel: 'text-xs md:text-[13px] lg:text-sm',
  feedbackTitle: 'text-[18px] md:text-[20px] lg:text-[22px]',
  thankYouMessage: 'text-xs md:text-[13px] lg:text-sm',

  loadMoreButton: 'text-xs font-black uppercase tracking-[0.06em]',
} as const;
